import { render, staticRenderFns } from "./ModalBills.vue?vue&type=template&id=6b99b5e2&"
import script from "./ModalBills.vue?vue&type=script&lang=js&"
export * from "./ModalBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports